<button [type]="type()" [class]="variant() + ' ' + size()" [disabled]="disabled()" (click)="handleClick($event)">
  <ng-content />
</button>
